<template>
    <div class="twofa-overlay" @click.self="onOutsideClick">
      <div class="twofa-dialog" ref="dialog">
      <div class="twofa-modal">
        <div class="fa_otp_header_logo"></div>
        <div class="google_ad_icon">
            <img src="@/assets/images/2fa-img/google_media_icon.svg">
          </div>
          <button class="twofa-close" @click="$emit('close')">✕</button>
        <div class="twofa-header">
          <h2 class="twofa-title">Verify Code</h2>
          <p class="twofa-subtitle">Please enter the 6-Digit code which appears on the authenticator app.</p>
          <p class="twofa-hint">Tap to copy the code in authenticator.</p>
        </div>
        <p class="twofa-label">Enter Code</p>
        <OtpInput
          v-model="otpCode"
          :length="6"
          :disabled="loading"
        />
        <button class="twofa-btn mt-3" :disabled="loading || otpCode.length < 6" @click="onVerify">
          <span v-if="loading">Verifying...</span>
          <span v-else>Verify</span>
        </button>
      </div>
    </div>
    </div>
</template>

<script>
import OtpInput from './OtpInput.vue';

export default {
  name: 'TwoFAModal',
  components: {
    OtpInput
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['verify', 'close'],
  data() {
    return {
      otpCode: '',
    };
  },
  mounted(){
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  },
  beforeUnmount() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  },
  methods: {
    onVerify() {
      if (this.otpCode.length === 6 && !this.loading) {
        this.$emit('verify', this.otpCode);
        this.otpCode = '';
      }
    },
    onOutsideClick() {
      const d = this.$refs.dialog;
      if (!d) return;
      d.classList.remove('twofa-dialog--static');
      void d.offsetWidth;
      d.classList.add('twofa-dialog--static');
      d.addEventListener('transitionend', () => d.classList.remove('twofa-dialog--static'), { once: true });
    },
  }
};
</script>

<style scoped>
.twofa-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.fa_otp_header_logo {
    top: -100px;
    background: linear-gradient(96deg,#CD4295 5.01%,#8F05BD 92.79%);
    position: absolute;
    width: 500px;
    height: 180px;
    left: -80px;
    border-radius: 50%;
}
.google_ad_icon {
    text-align: center;
    position: relative;
    margin-top: 20px;
}
.twofa-modal {
  background: #fff;
  border-radius: 12px;
  width: 350px;
  padding: 28px 24px 24px;
  position: relative;
  overflow: hidden;
}
.twofa-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: transparent;
  border: solid 2px #fff;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.twofa-header {
    text-align: left;
}
.twofa-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #fff;
  border: 1.5px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}
.twofa-title {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 6px;
    color: #12256D;
    border-bottom: solid 1px #EDEDED;
    padding-bottom: 6px;
}
.twofa-subtitle {
    font-size: 13px;
    color: #00223C;
    text-align: left;
    margin: 0 0 5px;
    line-height: 1.5;
    font-weight: 600;
}
.twofa-hint {
  font-size: 12px;
  color: #6E6E6E;
  text-align: left;
  margin: 0 0 10px;
}
.twofa-label {
  font-size: 13px;
  font-weight: 500;
  color: #01295D;
  margin: 0 0 10px;
}
.twofa-timer {
  text-align: center;
  font-size: 13px;
  color: #222;
  margin: 16px 0;
}
.twofa-timer-value {
  font-weight: 500;
  color: #555;
}
.twofa-timer--urgent {
  color: #E24B4A;
}
.twofa-btn {
    width: 100%;
    padding: 13px;
    color: #fff;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    letter-spacing: 0.3px;
    background: linear-gradient(278deg,#D442A6 -3.36%,rgba(235,0,255,.19) 117.81%),#081227;
}
.twofa-btn:disabled {
  background: #a0aec0;
  cursor: not-allowed;
}
.two-fa-verify-code-sec .form-control:focus {
    border-color: #12256D;
    border: 1.15px solid #12256D;
    background: #FAFBFF;
}
.twofa-resend {
  text-align: center;
  margin: 16px 0 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.twofa-expired-text {
  font-size: 13px;
  color: #E24B4A;
}
.twofa-resend-btn {
  background: none;
  border: none;
  color: #1a3a6b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}
.twofa-resend-btn:hover {
  color: #004D90;
}
.twofa-dialog {
  transform: none;
  transition: transform 0.3s ease-out;
}
.twofa-dialog--static {
  transform: scale(1.02);
}
.twofa-modal {
  background: #fff;
  border-radius: 18px;
  width: 340px;
  padding: 28px 24px 24px;
  position: relative;
  overflow: hidden;
}
</style>